<template>
  <div class="blocked-content-component">
    <div v-if="quiz">
      <div class="d-flex justify-content-center align-items-center w-100 mb-4">
        <i class="fa-solid fa-file-pen mr-3 text-white" />
        <p class="title">{{ quiz.title }}</p>
      </div>
      <template v-if="quiz.description">
        <p class="title mb-1">Orientações:</p>
        <div class="directions">
          {{ quiz.description }}
        </div>
        <hr class="divider" />
      </template>
      <hr />
    </div>
    <div>
      <p class="mb-4">{{ getLabel()[1] }}</p>
      <i class="fa-solid fa-lock mb-4" />
      <p>{{ getLabel()[2] }} {{ timeToRelease }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    quiz: {
      type: Object,
      default: null
    },
    isBlocked: {
      type: Object,
      required: true
    }
  },
  methods: {
    getLabel() {
      let map = {
        module: { 1: "Este módulo está bloqueado", 2: "Será liberado" },
        submodule: {
          1: "Este submódulo está bloqueado",
          2: "Será liberado"
        },
        quiz: { 1: "Esta avaliação está bloqueada", 2: "Será liberada" },
        lesson: { 1: "Esta aula está bloqueada", 2: "Será liberada" }
      };

      return map[this.isBlocked.blocked_by];
    }
  },
  computed: {
    timeToRelease() {
      let daysLeftForRelease = this.isBlocked.days_left_for_release;

      if (!daysLeftForRelease) return "em breve";
      return daysLeftForRelease == 1
        ? "amanhã"
        : `em ${daysLeftForRelease} dias`;
    }
  }
};
</script>
<style lang="scss">
.blocked-content-component {
  width: 100%;
  height: 100%;
  max-height: 437px;
  min-height: 437px;
  text-align: center;
  padding: 32px;
  align-content: center;
  background: linear-gradient(
    to bottom,
    hsl(252.86, 25%, 10.98%) 0%,
    hsl(252.63, 24.87%, 10.63%) 4.5%,
    hsl(252.37, 24.72%, 10.27%) 8.2%,
    hsl(252.08, 24.55%, 9.91%) 11.3%,
    hsl(251.76, 24.37%, 9.56%) 14.1%,
    hsl(251.4, 24.18%, 9.22%) 16.8%,
    hsl(251, 23.96%, 8.88%) 19.8%,
    hsl(250.57, 23.73%, 8.56%) 23.3%,
    hsl(250.1, 23.49%, 8.25%) 27.5%,
    hsl(249.61, 23.24%, 7.97%) 32.7%,
    hsl(249.11, 22.99%, 7.72%) 39.2%,
    hsl(248.63, 22.75%, 7.49%) 47.2%,
    hsl(248.18, 22.54%, 7.31%) 57.1%,
    hsl(247.82, 22.37%, 7.17%) 69%,
    hsl(247.58, 22.26%, 7.09%) 83.2%,
    hsl(247.5, 22.22%, 7.06%) 100%
  );

  @media screen and (max-width: 768px) {
    min-height: 241px;
  }
  p {
    font-size: 14px;
    font-weight: 500 !important;
    color: #fff;
    margin: 0;
  }

  .title {
    font-size: 18px !important;
  }

  .directions {
    font-size: 14px;
    color: #bebfc7;
  }

  .divider {
    margin-block: 32px;
    background-color: rgba(57, 52, 68, 1);
  }

  i {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.8);

    &.fa-lock {
      font-size: 30px;
    }
  }
}
</style>
